<template>
  <vs-popup class="create-sundry-supplier-popup"
            id="popup"
            title="CREATE SUNDRY ITEM"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSundryItem)" autocomplete="off">

          <div class="vx-row mb-3" v-if="!id">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="supplier_id" name="supplier_id" rules="required" v-slot="{ errors }">
                <small class="label">Sundry Supplier</small>
                <v-select @search="onSearch" :clearable="true" name="supplier_id" placeholder=""
                          label="company_name" v-model="createForm.supplier_id" :reduce="option => option.id"
                          :options="suppliers" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="no-options">
                    type to search sundry supplier
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sundry_product_code" name="sundry_product_code" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Code</small>
                <vs-input v-model="createForm.sundry_product_code"   name="sundry_product_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sundry_product_name" name="sundry_product_name" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Name</small>
                <vs-input v-model="createForm.sundry_product_name"   name="sundry_product_name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country_manufacture" name="country_manufacture" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :filter-by="myFilter"  :clearable="false" name="country_manufacture" placeholder="" label="name" v-model="createForm.country_manufacture" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sold_in" name="sold_in" rules="required" v-slot="{ errors }">
                <small class="label">Sold In</small>
                <v-select  :clearable="false" name="sold_in" placeholder="" v-model="createForm.sold_in" :reduce="option => option" :options="['kg', 'l', 'units']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="min_OQ" name="min_OQ" rules="required|moq:1" v-slot="{ errors }">
                <small class="label">Min Order Quantity {{ selected_unit }}</small>
                <vs-input type="number" step="1" v-model="createForm.min_OQ"   name="min_OQ" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="packaging_size" name="packaging_size" rules="" v-slot="{ errors }">
                <small class="label">Quantity In Each Pack/Box {{ selected_unit }}</small>
                <vs-input type="number" step="1" v-model="createForm.packaging_size"   name="packaging_size" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="unit_price" name="unit_price" rules="required|two_decimal" v-slot="{ errors }">
                <small class="label">Unit Price</small>
                <vs-input type="number" step="any" v-model="createForm.unit_price"   name="unit_price" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
                <small class="label">Shipping File (.doc, .jpg, .pdf, .jpeg, .png, .docx, .txt)</small>
                <file-uploader-not-required
                  v-on:onSetFileName="value => createForm.shipping_handling = value"
                  v-on:onClickFileRemove="createForm.shipping_handling = null"
                  :file="createForm.shipping_handling"
                  :condition="true"/>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="is_low_stock_threshold_required" name="is_low_stock_threshold_required" rules="" v-slot="{ errors }">
                <small class="label">Do you want to set a low stock level warning?</small>
                <vs-switch  v-model="createForm.is_low_stock_threshold_required" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="createForm.is_low_stock_threshold_required">
              <ValidationProvider vid="low_stock_threshold" name="low_stock_threshold" rules="required" v-slot="{ errors }">
                <small class="label">Threshold (KG)</small>
                <vs-input type="number" step="0.001" v-model="createForm.low_stock_threshold" name="low_stock_threshold" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <small class="label">Nominal Code</small>
              <v-select :clearable="false" name="nominal_code" placeholder=""
                        label="name" v-model="createForm.sage_nominal_code_id" :reduce="option => option.id"
                        :options="sage_nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea  class="mb-0" v-model="createForm.description" />
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="additional_information" name="additional_information" rules="" v-slot="{ errors }">
                <small class="label">Additional Information</small>
                <vs-textarea  class="mb-0" v-model="createForm.additional_information" />
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SundrySupplierRepository = RepositoryFactory.get('sundry')
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');
  const DropDownRepository = RepositoryFactory.get('drop_down')


  function initialState() {
    return {
      open: false,
      createForm: {
        is_low_stock_threshold_required: false,
        low_stock_threshold: 0
      },
      countryCodes: [],
      suppliers: [],
      id: '',
      sage_nominal_codes:[]
    }
  }

export default {
  name: 'CreateSundryItemPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = id
        await this.loadCountrCode()
        await this.getSageNominalCodes()
        this.open = true;
      } catch (error) {

      }
    },

    async loadCountrCode() {
      this.$vs.loading()
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
      this.$vs.loading.close()
    },
    async getSageNominalCodes(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
      this.sage_nominal_codes =  data.data
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async onClickCreateSundryItem () {
      const vue = this;
      this.$vs.loading()
       try {
         let payload = this.createForm
         if(!!this.id) {
           payload.supplier_id = this.id
         }
         payload.unit_price = Number(payload.unit_price).toFixed(2)
         if(!payload.is_low_stock_threshold_required) {
            delete payload.low_stock_threshold
          } else {
            payload.low_stock_threshold = Number(payload.low_stock_threshold).toFixed(4)
          }
         await SundrySupplierRepository.createSundryItem(payload)
         this.showSuccessMessage('Sundry item created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce( async (loading, search, vm) => {
      // const {data} = await SundrySupplierRepository.getListOfApprovedSundrySuppliers(1, `filter[search]=${search}`, 50, '')
      const {data} = await DropDownRepository.getApprovedSundrySupplierList( `filter[search]=${search}`)
      vm.suppliers = data.data
      loading(false);
    }, 350),
  },
  computed: {
    selected_unit: function () {
      if(!this.createForm.sold_in) return null
      return `(${this.createForm.sold_in})`
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .create-sundry-supplier-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
</style>
